import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router'
import { textContrastIsAA } from 'helpers/getContrast'

import HideVisually from 'js/components/HideVisually/HideVisually'

import styles from './NavigationMenu.module.css'
import NavigationMenuItem, { getMenuItemClassName } from './NavigationMenuItem'

const NavigationMenu = ({ site }) => {
    const { t } = useTranslation()

    if (!site) {
        return null
    }

    const headerMain = getComputedStyle(document.documentElement)
        .getPropertyValue('--ref-palette-header-main')
        .trim()
    const currentReadable = textContrastIsAA(headerMain)

    return (
        <nav className={styles.element}>
            <ul>
                <li>
                    <NavLink
                        to="/"
                        className={getMenuItemClassName(
                            !site.showIcon,
                            currentReadable,
                        )}
                        end
                    >
                        {site.showIcon ? (
                            <>
                                <HideVisually>
                                    {t('global.home-page')}
                                </HideVisually>
                                <img
                                    src={site.icon}
                                    alt={site.iconAlt ?? ''}
                                    width="auto"
                                    height="auto"
                                    aria-hidden={!site.iconAlt}
                                />
                            </>
                        ) : (
                            <span>{t('global.home-title')}</span>
                        )}
                    </NavLink>
                </li>

                {site.menu.map((item, i) => (
                    <NavigationMenuItem key={`nav-menu-item${i}`} item={item} />
                ))}
            </ul>
        </nav>
    )
}

export default NavigationMenu
